import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';



import * as globalConst from './../../../constants';

@Injectable()
export class SerasaService {

  private apiUrl = globalConst.baseAPI;  // URL para web api
  
    /**
    * Método construtor
    * @param http: Http
    */
    constructor(private http: Http) {}



    requestSerasaByID(serasaID){
      
      return this.http
      .get(this.apiUrl + "/serasa/v1/detailhistory/"+serasaID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
        return Observable.throw('Unauthorized');
        }
      });
    }

    getSerasaHistory(userID, page){

      page = page * globalConst.paginationSkip;
      
      return this.http
      .get(this.apiUrl + "/serasa/v1/history/"+userID+"/?$orderby=DataCriacao desc&$top="+globalConst.paginationSkip+"&$skip=" + page, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
        return Observable.throw('Unauthorized');
        }
      });
    }

}





// WEBPACK FOOTER //
// ./src/app/serasa/service/serasa.service.ts